import React from 'react'
import "./stack.css"
const FrontendStack = () => {
  return (
    <div className='stack-card'>
        <h4>Frontend</h4>
        <div className='stack-card-list'>
            <p>HTML</p>
            <p>CSS</p>
            <p>Tailwind</p>
            <p className='stack-border-color-js'>Javascript</p>
            <p className='stack-border-color-rj'>React Js</p>
            <p>Next Js 14</p>
        </div>
    </div>
  )
}

export default FrontendStack